module.exports = __webpack_public_path__ + "static/hkVisa-d6885d5d8ba9ce1c367c3eeefe6802ee.jpg";